import {
  $convertToMarkdownString,
  $convertFromMarkdownString,
  TEXT_MATCH_TRANSFORMERS,
  LINK,
  BOLD_STAR,
  ITALIC_UNDERSCORE,
  type TextFormatTransformer,
} from "@lexical/markdown";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { OnChangePlugin } from "@lexical/react/LexicalOnChangePlugin";
import React, { useCallback } from "react";
import { TABLE } from "../Table/transformers/TableTransformer";
import { EQUATION } from "../Equation/transformers/EquationTransformer";

const ITALIC_UNDERSCORE_INTRAWORD: TextFormatTransformer = {
  ...ITALIC_UNDERSCORE,
  intraword: true,
};

export function convertFromMarkdown(markdown: string) {
  return $convertFromMarkdownString(
    markdown,
    [EQUATION, LINK, ITALIC_UNDERSCORE_INTRAWORD, BOLD_STAR, TABLE, ...TEXT_MATCH_TRANSFORMERS],
    undefined,
    true,
  );
}

export function MarkdownConverterPlugin({
  onConversion,
}: {
  onConversion: (markdown: string) => void;
}) {
  const [editor] = useLexicalComposerContext();

  const convertToMarkdown = useCallback(() => {
    editor.update(() => {
      const markdown = $convertToMarkdownString([
        EQUATION,
        LINK,
        ITALIC_UNDERSCORE_INTRAWORD,
        BOLD_STAR,
        TABLE,
        ...TEXT_MATCH_TRANSFORMERS,
      ]);
      onConversion(markdown);
    });
  }, [editor, onConversion]);

  return <OnChangePlugin onChange={convertToMarkdown} ignoreSelectionChange />;
}
